import { CountryModel } from '../../domain/models/country.model';
import { Mapper } from '../../utilitis/base/mapper';
import { CountryEntitie } from '../entities/country.entitie';

export class CountryMapper extends Mapper<
    CountryEntitie[] | CountryEntitie,
    CountryModel[] | CountryModel
> {
    mapperArrayFrom(payload: CountryEntitie[]): CountryModel[] {
        let countryFormat: CountryModel[] = [];

        payload.forEach((element: CountryEntitie) => {
            countryFormat.push({
                id: element.id,
                code: element.iso2,
                name: element.name,
            });
        });

        return countryFormat;
    }

    mapperFrom(payload: CountryEntitie): CountryModel {
        return {
            id: payload.id,
            name: payload.name,
            code: payload.iso2 ? payload.iso2 : '',
        };
    }

    mapperTo(payload: CountryModel): CountryEntitie {
        return {
            id: payload.id,
            name: payload.name,
            iso2: payload.code,
        };
    }
}
